export default class TipoProjetoTipoAtividade {

  constructor(
    IdTipoProjeto = null,
    IdTipoAtividade = null,
    TipoAtividade = '',
  ) {
    this.IdTipoProjeto = IdTipoProjeto;
    this.IdTipoAtividade = IdTipoAtividade;
    this.TipoAtividade = TipoAtividade;
  }
  
}